import { IonContent, IonPage } from '@ionic/react'
import { useSelector } from 'react-redux'

import { clusterFrontend } from '../apiConfig'
import DummyHeader from '../components/DummyHeader'
import { selectSession } from '../store'

const iframeTitle = 'cluster'

export default function Cluster() {
  const { authToken } = useSelector(selectSession)

  return (
    <IonPage>
      <DummyHeader />
      <IonContent>
        <iframe className="h-full overflow-scroll" title={iframeTitle} src={`${clusterFrontend}?token=${authToken}`} width="100%" height="1000%" allowFullScreen />
      </IonContent>
    </IonPage>
  )
}
